export default __webpack_public_path__ + "static/upsidedown-74530fc21aa357b6554b520edbd6167a.png";